import { User } from '../../auth/model/user';
import { AccessControlEnum } from '../../core/models/access-control.enum';

export class UrlHelper {
  public static getDefaultUrl(user: User, url: string = '/'): string {
    if ((url === '/' || url === '/overview') && user && user.modules && user.modules.indexOf(AccessControlEnum.OverviewModule) === -1){
      if (user.modules.indexOf(AccessControlEnum.RoutesModule) > -1) {
        return '/tracks';
      } else if (user.modules.indexOf(AccessControlEnum.VehicleModule) > -1) {
        return '/vehicles';
      } else if (user.modules.indexOf(AccessControlEnum.ReportModule) > -1) {
        return '/report';
      } else if (user.modules.indexOf(AccessControlEnum.ServiceBookModule) > -1) {
        return '/costModule';
      } else if (user.modules.indexOf(AccessControlEnum.FuelModule) > -1) {
        return '/fuelCard';
      } else if (user.modules.indexOf(AccessControlEnum.ZonesModule) > -1) {
        return '/zones';
      } else if (user.modules.indexOf(AccessControlEnum.SettingsModule) > -1) {
        return '/settings';
      }
      else {
        return '/errors/no-access';
      }
    }
    return url || '/';
  }
}
